"use strict";

/**
 * @module Services.Control
 */
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.GetSessionPropertiesResponse = void 0;
/**
 * Server response from a GET_SESSION_PROPERTIES request.
 */
var GetSessionPropertiesResponse = /** @class */function () {
  /**
   * Create a new GetSessionPropertiesResponse instance
   *
   * @param properties  the session properties
   */
  function GetSessionPropertiesResponse(properties) {
    this.properties = properties;
  }
  /**
   * Convert object to string
   *
   * @return  a string representation of the GetSessionPropertiesResponse object
   */
  GetSessionPropertiesResponse.prototype.toString = function () {
    return 'GetSessionPropertiesResponse []';
  };
  return GetSessionPropertiesResponse;
}();
exports.GetSessionPropertiesResponse = GetSessionPropertiesResponse;